<template>
  <div>
    <template v-if="catalogV2Enabled">
      <div
        class="sticky-below-header !top-[--layout-offset-top] z-10 bg-white py-2 shadow shadow-black/5"
      >
        <tag-page-navigation base-route-item />
      </div>

      <nuxt-page :page-key="$route.path" />
    </template>

    <div v-else class="bg-gradient-to-b from-primary-100 to-[20vh] pt-6">
      <catalog-navigation class="pb-6" :sticky="stickySubnavigation" />

      <nuxt-page :page-key="$route.path" />
    </div>
  </div>
</template>

<script lang="ts" setup>
import CatalogNavigation from "~/pages/catalog/_includes/components/old/catalog-navigation.vue";

const catalogV2Enabled = useFeatureFlag("catalog_v2");

const stickySubnavigation = computed(
  () => (useRoute().meta.stickyCatalogNavigation as boolean) ?? true,
);
</script>
